import React, { useState, useEffect, useCallback } from "react";
import { Select as ChakraSelect } from "@chakra-ui/react";
import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
  // Sorting state
import {
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Box,
  Input,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useToast,
  useColorModeValue,
  useBreakpointValue,
  SimpleGrid,
  Textarea,
  FormControl,
} from "@chakra-ui/react";
import { MdDelete, MdEdit, MdAdd, MdCheck, MdClose } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import Card from "components/card/Card";
import fetchWithToken from "views/auth/signIn/axiosInstance";
import CreateBranch from "./createBranch";
import { useTranslation } from "react-i18next";
import Map from "views/map/map";
import ViewBranchAccordionModal from "./ViewBranchAccordionModal";

export const BranchList = () => {
  const { t } = useTranslation();
  const [branches, setBranches] = useState([]);
  const [filterActive, setFilterActive] = useState("");
  const [filteredBranches, setFilteredBranches] = useState([]);
    const [dateSortOrder, setDateSortOrder] = useState("desc");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [branchesPerPage, setBranchesPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [editableBranch, setEditableBranch] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [viewingBranch, setViewingBranch] = useState(null);
  const [showCreateBranchModal, setShowCreateBranchModal] = useState(false);
  const [managers, setManagers] = useState([]);
  // Remove old page const
  const toast = useToast();
  const modalSize = useBreakpointValue({ base: "full", md: "xl" });
  const textColor = useColorModeValue("secondaryGray.900", "white");

  const companyId = sessionStorage.getItem("CompanyID");
  const pageId = 12; 
  const handlePolygonComplete = (polygon) => {
    setEditableBranch((prevData) => ({
      ...prevData,
      geofence: {
        type: "Polygon",
        coordinates: polygon,
      },
    }));
  };

  // Fetch branches with pagination and optional active filter
  const fetchBranches = useCallback(async (pageNum = 1, sortOrder = dateSortOrder) => {
    try {
      let url = `${process.env.REACT_APP_API_URL2}/admin/branches?page=${pageNum}&limit=${branchesPerPage}&sort_by=created_at&sort_order=${sortOrder}&page_id=${pageId}`;
      if (filterActive !== "") {
        url += `&active=${filterActive === "true" ? 1 : filterActive === "false" ? 0 : filterActive}`;
      }
      const data = await fetchWithToken(url);
      setBranches(data.data);
      setFilteredBranches(data.data);
      // Support both last_page and total_pages
      const pages = data.pagination?.total_pages || data.pagination?.last_page || 1;
      setTotalPages(pages);
      toast({
        title: "Branches fetched successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    } catch (error) {
      toast({
        title: "An error occurred.",
        description: error.message || "Failed to fetch branches. Using initial data.",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    }
  }, [branchesPerPage, toast, dateSortOrder, filterActive, pageId]);

  useEffect(() => {
    fetchBranches(currentPage, dateSortOrder);
  }, [fetchBranches, currentPage, branchesPerPage, dateSortOrder, filterActive, pageId]);

  // useEffect(() => {
  //   const fetchManagers = async () => {
  //     try {
  //       const data = await fetchWithToken(
  //         `${process.env.REACT_APP_API_URL2}/managers?company_id=${companyId}`
  //       );
  //       setManagers(data.data);
  //     } catch (error) {
  //       console.error("Failed to fetch managers:", error);
  //     }
  //   };

  //   fetchManagers();
  // }, []);

  const handleDeleteBranch = async (branch) => {
    try {
      const response = await fetchWithToken(
        `${process.env.REACT_APP_API_URL2}/branches/${branch.id}`,
        "DELETE"
      );
      if (!response) {
        throw new Error("Failed to delete branch");
      }
      setBranches((prevBranches) =>
        prevBranches.filter((b) => b.id !== branch.id)
      );
      setFilteredBranches((prevFilteredBranches) =>
        prevFilteredBranches.filter((b) => b.id !== branch.id)
      );
      toast({
        title: "Branch deleted successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    } catch (error) {
      toast({
        title: "An error occurred.",
        description: error.message || "Failed to delete branch.",
        status: "error",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    }
  };

  const handleViewBranch = async (branch) => {
    try {
      const data = await fetchWithToken(
        `${process.env.REACT_APP_API_URL2}/admin/branches/branch?branch_id=${branch.id}&page_id=${pageId}`
      );
      console.log("Fetched branch details:", data);
      setViewingBranch(data.data); // Update editableBranch with the fetched details
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Failed to fetch branch details",
        status: "error",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    }
  };

  const handleEditBranch = async (branch) => {
    try {
      const data = await fetchWithToken(`${process.env.REACT_APP_API_URL2}/branches/branch?branch_id=${branch.id}`);
        setEditableBranch(data.data); // Update editableBranch with the fetched details
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Failed to fetch branch details",
        status: "error",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });// Show error toast
    }
  };

  const handleSaveBranch = async () => {
    try {
      const data = {
        branch_id: editableBranch.id,
        name: editableBranch.name,
        about: editableBranch.about,
        address_line1: editableBranch.address_line1,
        address_line2: editableBranch.address_line2,
        branch_manager_id: editableBranch.manager_id,
        city: editableBranch.city,
        state: editableBranch.state,
        phone_number: editableBranch.phone_number,
        email: editableBranch.email,
        delivery_fee: editableBranch.delivery_fee,
        clean_at_location: editableBranch.clean_at_location,
        free_delivery: editableBranch.free_delivery,
        minimum_order_amount: editableBranch.minimum_order_amount,
        uc_wallet: editableBranch.uc_wallet,
        uc_delivery: editableBranch.uc_delivery,
        postal_code: editableBranch.postal_code,
        country: editableBranch.country,
        latitude: editableBranch.latitude,
        longitude: editableBranch.longitude,        status: editableBranch.status,
        created_at: editableBranch.created_at,
        updated_at: editableBranch.updated_at,
        geofence: editableBranch.geofence,
        is_active: editableBranch.is_active,
        completion_date: editableBranch.completion_date,
      };
      setIsSubmitting(true);
      const response = await fetchWithToken(
        `${process.env.REACT_APP_API_URL}/branch/update?page_id=${pageId}`,
        "PATCH",
        data
      );
      if (!response) {
        throw new Error("Failed to update branch");
      }
      setBranches((prevBranches) =>
        prevBranches.map((b) =>
          b.id === editableBranch.id ? editableBranch : b
        )
      );
      setFilteredBranches((prevFilteredBranches) =>
        prevFilteredBranches.map((b) =>
          b.id === editableBranch.id ? editableBranch : b
        )
      );
      setEditableBranch(null);
      toast({
        title: "Branch updated successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    } catch (error) {
      toast({
        title: "An error occurred.",
        description: error.message || "Failed to update branch.",
        status: "error",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // New function to update branch activity
  const handleUpdateBranchActivity = async (branch, newStatus) => {
    try {
      const payload = {
        branch_id: branch.id,
        is_active: newStatus ? 1 : 0,
      };
      const response = await fetchWithToken(
        `${process.env.REACT_APP_API_URL2}/branch/activity/update?page_id=${pageId}`,
        "PATCH",
        payload
      );
      if (!response) throw new Error("Failed to update branch activity");
      // Update branch in state arrays
      setBranches((prev) =>
        prev.map((b) =>
          b.id === branch.id ? { ...b, is_active: newStatus } : b
        )
      );
      setFilteredBranches((prev) =>
        prev.map((b) =>
          b.id === branch.id ? { ...b, is_active: newStatus } : b
        )
      );
      toast({
        title: `Branch ${newStatus ? "activated" : "deactivated"} successfully.`,
        status: "success",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    } catch (error) {
      toast({
        title: "An error occurred.",
        description: error.message || "Failed to update branch activity.",
        status: "error",
        duration: 5000,
        isClosable: true,
position: "top-right",

      });
    }
  };


  const handleLocationSelect = (location) => {
    // Update latitude and longitude of the editable branch
    setEditableBranch({
      ...editableBranch,
      latitude: parseFloat(location.lat),
      longitude: parseFloat(location.lng),
    });
  };

  const handleCloseViewingModal = () => {
    setViewingBranch(null);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    // Optionally, you can filter on the server by refetching with a search param
    const filtered = branches.filter((branch) =>
      branch.name.toLowerCase().includes(query.toLowerCase())||
      branch.city.toLowerCase().includes(query.toLowerCase())||
      branch.phone_number.toLowerCase().includes(query.toLowerCase())||
      branch.company.name.toLowerCase().includes(query.toLowerCase())

    );
    setFilteredBranches(filtered);
    setCurrentPage(1);
  };

  return (
    <Card
      direction="column"
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex
        px={{ base: "10px", md: "25px" }}
        justify="space-between"
        mb="20px"
        align="center"
        flexWrap="wrap"
      >
        <Flex align="center" w="100%">
          <Text
            color="gray.800"
            fontSize={{ base: "18px", md: "22px" }}
            fontWeight="700"
            lineHeight="100%"
            mb={{ base: "10px", md: "0" }}
          >
            {t("Branch List")}
          </Text>
          {/* <Button ... */}
          <FormControl maxW={{ base: "100%", md: "120px" }} ml="auto" mr={4}>
            <Select
              value={branchesPerPage}
              onChange={(e) => {
                setBranchesPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
              size="sm"
              focusBorderColor="blue.400"
              borderRadius={"md"}
              _hover={{ borderColor: "blue.400",
                boxShadow: "0 0 0 1px #3182CE",
                color: "blue.400",
                backgroundColor: "blue.50"
              }}
            >
              <option value="10">10 {t("per page")}</option>
              <option value="20">20 {t("per page")}</option>
              <option value="50">50 {t("per page")}</option>
            </Select>
          </FormControl>
          {/* Active Status Filter */}
          <FormControl maxW={{ base: "100%", md: "180px" }} mr={4}>
            <ChakraSelect
              placeholder={t("Select Active Status")}
              value={filterActive}
              onChange={(e) => {
                setFilterActive(e.target.value);
                setCurrentPage(1);
              }}
              size="sm"
              focusBorderColor="blue.400"
              borderRadius={"md"}
              _hover={{ borderColor: "blue.400",
                boxShadow: "0 0 0 1px #3182CE",
                color: "blue.400",
                backgroundColor: "blue.50"
              }}
            >
              <option value="true">{t("Active: Yes")}</option>
              <option value="false">{t("Active: No")}</option>
            </ChakraSelect>
          </FormControl>
          <Input
            placeholder={t("Search branch...")}
            value={searchQuery}
            onChange={handleSearch}
            size="sm"
            w={{ base: "100%", md: "200px" }}
            ml={2}
          />
        </Flex>
      </Flex>
      <Box overflowY="auto" maxHeight="400px">
        <Table variant="simple" color="gray.500" mb="24px">
              <Thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                  <Tr bg='rgb(69, 50, 240)' textColor="white" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
              <Th textColor="white">{t("Index")}</Th>
              <Th textColor="white">{t("Company")}</Th>
              <Th textColor="white">{t("Name")}</Th>
              {/* <Th textColor="white">{t("Manager")}</Th> */}
              <Th textColor="white">{t("City")}</Th>
              <Th textColor="white">{t("Phone")}</Th>
              <Th
                color="white"
                cursor="pointer"
                onClick={() => {
                  setDateSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
                }}
              >
                {t("Date")}
                {dateSortOrder === "asc" ? (
                  <TriangleUpIcon ml={2} />
                ) : (
                  <TriangleDownIcon ml={2} />
                )}
              </Th>
              <Th textColor="white">{t("Active")}</Th>
              <Th textColor="white">{t("Actions")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredBranches.map((branch, index) => (
              <Tr key={branch.id}>
                <Td>{(currentPage - 1) * branchesPerPage + index + 1}</Td>
                <Td>{branch.company.name}</Td>
                <Td>{branch.name}</Td>
                {/* <Td>{branch.manager}</Td> */}
                <Td>{branch.city}</Td>
                <Td>{branch.phone_number}</Td>
                <Td>{new Date(branch.created_at).toLocaleDateString()}</Td>
                <Td>{branch.is_active? "Yes": "No"}</Td>
                <Td>
                  <Flex>
                    {/* <Button
                      colorScheme="cyan"
                      size="sm"
                      onClick={() => handleEditBranch(branch)}
                      borderRadius="full"
                      color="white"
                      boxShadow="md"
                      _hover={{ bg: "cyan.600", transform: "scale(1.05)" }}
                      _active={{ bg: "cyan.700", transform: "scale(0.95)" }}
                      transition="all 0.2s"
                    >
                      <MdEdit />
                    </Button> */}
                    <Button
                      colorScheme="teal"
                      size="sm"
                      ml={2}
                      onClick={() => handleViewBranch(branch)}
                      borderRadius="full"
                      boxShadow="md"
                      _hover={{ bg: "teal.600", transform: "scale(1.05)" }}
                      _active={{ bg: "teal.700", transform: "scale(0.95)" }}
                      transition="all 0.2s"
                      leftIcon={<IoMdEye />}
                    >
                      {t("View")}
                    </Button>
                    <Button
                      colorScheme={branch.is_active ? "red" : "green"}
                      size="sm"
                      ml={2}
                      onClick={() =>
                        handleUpdateBranchActivity(branch, !branch.is_active)
                      }
                      borderRadius="full"
                      boxShadow="md"
                      _hover={{
                        bg: branch.is_active ? "red.600" : "green.600",
                        transform: "scale(1.05)",
                      }}
                      _active={{
                        bg: branch.is_active ? "red.700" : "green.700",
                        transform: "scale(0.95)",
                      }}
                      transition="all 0.2s"
                      leftIcon={branch.is_active ? <MdClose /> : <MdCheck />}
                    >
                      {branch.is_active ? t("Deactivate") : t("Activate")}
                    </Button>
                  </Flex>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      {/* Pagination Controls */}
      {totalPages > 0 && (
        <Box mt={4} mb={4}>
          <Text textAlign="center" fontSize="sm" color="gray.600" mb={3}>
            {t("Page")} {currentPage} {t("of")} {totalPages}
            {filteredBranches.length > 0 && (
              <span> - {t("Showing")} {((currentPage - 1) * branchesPerPage) + 1} {t("to")} {Math.min(currentPage * branchesPerPage, ((currentPage - 1) * branchesPerPage) + filteredBranches.length)} {t("results")}</span>
            )}
          </Text>
          <Flex justifyContent="center" wrap="wrap" gap={2}>
            <Button
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
              size="sm"
              variant="outline"
              display={{ base: currentPage > 3 ? "block" : "none", md: currentPage > 2 ? "block" : "none" }}
            >
              {t("First")}
            </Button>
            <Button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              size="sm"
              colorScheme="cyan"
              variant="outline"
            >
              {t("Previous")}
            </Button>
            {/* Page Numbers with smart ellipsis */}
            {(() => {
              const delta = 2;
              const range = [];
              const rangeWithDots = [];
              for (let i = Math.max(2, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
                range.push(i);
              }
              if (currentPage - delta > 2) {
                rangeWithDots.push(1, '...');
              } else {
                rangeWithDots.push(1);
              }
              rangeWithDots.push(...range);
              if (currentPage + delta < totalPages - 1) {
                rangeWithDots.push('...', totalPages);
              } else if (totalPages > 1) {
                rangeWithDots.push(totalPages);
              }
              return rangeWithDots.map((page, index) => {
                if (page === '...') {
                  return (
                    <Text key={`ellipsis-${index}`} mx={2} alignSelf="center" fontSize="sm" color="gray.500">...</Text>
                  );
                }
                return (
                  <Button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    variant={currentPage === page ? "solid" : "outline"}
                    colorScheme={currentPage === page ? "cyan" : "gray"}
                    color={'blue'}
                    size="sm"
                    minW="40px"
                  >
                    {page}
                  </Button>
                );
              });
            })()}
            <Button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              size="sm"
              colorScheme="cyan"
              variant="outline"
            >
              {t("Next")}
            </Button>
            <Button
              onClick={() => setCurrentPage(totalPages)}
              disabled={currentPage === totalPages}
              size="sm"
              variant="outline"
              display={{ base: currentPage < totalPages - 2 ? "block" : "none", md: currentPage < totalPages - 1 ? "block" : "none" }}
            >
              {t("Last")}
            </Button>
          </Flex>
        </Box>
      )}

      {/* Edit Branch Modal */}
      {editableBranch && (
        <Modal
          isOpen={true}
          onClose={() => setEditableBranch(null)}
          size={modalSize}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                {t("Edit Branch")}
              </Text>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
                {/* Name */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Name")}
                  </Text>
                  <Input
                    value={editableBranch.name}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        name: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* About */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("About")}
                  </Text>
                  <Textarea
                    value={editableBranch.about || ""}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        about: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Manager */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Manager")}
                  </Text>
                  <Select
                    value={editableBranch.branch_manager_id}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        uc_wallet: parseInt(e.target.value),
                      })
                    }
                  >
                    {managers.map((manager) => (
                      <option key={manager.id} value={manager.id}>
                        {manager.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                {/* Address Line 1 */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Address Line 1")}
                  </Text>
                  <Input
                    value={editableBranch.address_line1 || ""}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        address_line1: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Address Line 2 */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Address Line 2")}
                  </Text>
                  <Input
                    value={editableBranch.address_line2 || ""}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        address_line2: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* City */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("City")}
                  </Text>
                  <Input
                    value={editableBranch.city}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        city: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* State */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("State")}
                  </Text>
                  <Input
                    value={editableBranch.state}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        state: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Postal Code */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Postal Code")}
                  </Text>
                  <Input
                    value={editableBranch.postal_code}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        postal_code: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Country */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Country")}
                  </Text>
                  <Input
                    value={editableBranch.country || ""}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        country: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Phone Number */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Phone")}
                  </Text>
                  <Input
                    value={editableBranch.phone_number}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        phone_number: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Email */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Email")}
                  </Text>
                  <Input
                    type="email"
                    value={editableBranch.email || ""}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        email: e.target.value,
                      })
                    }
                  />
                </Box>
                {/* Minimum Order Amount */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Minimum Order Amount")}
                  </Text>
                  <Input
                    value={editableBranch.minimum_order_amount}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        minimum_order_amount: parseInt(e.target.value),
                      })
                    }
                  />
                </Box>
                {/* UC Wallet */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("UC Wallet")}
                  </Text>
                  <Select
                    value={editableBranch.uc_wallet}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        uc_wallet: parseInt(e.target.value),
                      })
                    }
                  >
                    <option value="1">{t("Yes")}</option>
                    <option value="0">{t("No")}</option>
                  </Select>
                </Box>
                {/* Free Delivery */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Free Delivery")}
                  </Text>
                  <Select
                    value={editableBranch.free_delivery ? "true" : "false"}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        free_delivery: e.target.value === "true",
                      })
                    }
                  >
                    <option value="true">{t("Yes")}</option>
                    <option value="false">{t("No")}</option>
                  </Select>
                </Box>
                {/* UC Delivery */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("UC Delivery")}
                  </Text>
                  <Select
                    value={editableBranch.uc_delivery}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        uc_delivery: parseInt(e.target.value),
                      })
                    }
                  >
                    <option value="1">{t("Yes")}</option>
                    <option value="0">{t("No")}</option>
                  </Select>
                </Box>
                {editableBranch.uc_delivery === 0 && (
                  <>
                    <Box>
                      <Text fontSize="sm" color="gray.500" mb="2">
                        {t("Delivery Fee")}
                      </Text>
                      <Input
                        value={editableBranch.delivery_fee}
                        onChange={(e) =>
                          setEditableBranch({
                            ...editableBranch,
                            delivery_fee: parseFloat(e.target.value),
                          })
                        }
                      />
                    </Box>

                    <Box>
                      <Text fontSize="sm" color="gray.500" mb="2">
                        {t("Clean at Location Fee")}
                      </Text>
                      <Input
                        value={editableBranch.clean_at_location}
                        onChange={(e) =>
                          setEditableBranch({
                            ...editableBranch,
                            clean_at_location: parseFloat(e.target.value),
                          })
                        }
                      />
                    </Box>
                  </>
                )}                {/* Status (disabled) */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Status")}
                  </Text>
                  <Select
                    isDisabled
                    value={editableBranch.status}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        status: e.target.value,
                      })
                    }
                  >
                    <option value="open">{t("Open")}</option>
                    <option value="closed">{t("Closed")}</option>
                  </Select>
                </Box>
                {/* Completion Date */}
                <Box>
                  <Text fontSize="sm" color="gray.500" mb="2">
                    {t("Completion Date (Hours)")}
                  </Text>
                  <Select
                    value={editableBranch.completion_date || 12}
                    onChange={(e) =>
                      setEditableBranch({
                        ...editableBranch,
                        completion_date: parseInt(e.target.value),
                      })
                    }
                  >
                    <option value="12">12 {t("Hours")}</option>
                    <option value="24">24 {t("Hours")}</option>
                    <option value="48">48 {t("Hours")}</option>
                    <option value="72">72 {t("Hours")}</option>
                    <option value="96">96 {t("Hours")}</option>
                    <option value="120">120 {t("Hours")}</option>
                  </Select>
                </Box>
              </SimpleGrid>
              {/* Map section can be enabled as needed */}
            </ModalBody>
            <ModalFooter>
              <Button
                colorScheme="cyan"
                color="white"
                onClick={handleSaveBranch}
                isLoading={isSubmitting}
              >
                {t("Save")}
              </Button>
              <Button
                colorScheme="red"
                ml={3}
                onClick={() => setEditableBranch(null)}
              >
                {t("Cancel")}
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}

      {/* View Branch Details Modal */}
      {viewingBranch && (
        <ViewBranchAccordionModal
        t={t}
        viewingBranch={viewingBranch}
        onClose={() => setViewingBranch(null)}
        modalSize="6xl"
        // (optional) to show names for category ids:
        // serviceCategories={[{id:1,name:"Laundry"}, {id:2,name:"Dry Clean"}]}
      />
      )}


      {/* <Modal
        isOpen={showCreateBranchModal}
        onClose={() => setShowCreateBranchModal(false)}
        size={"2xl"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Text color={textColor} fontSize="2xl" fontWeight="700">
              {t("Create Branch")}
            </Text>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <CreateBranch />
          </ModalBody>
        </ModalContent>
      </Modal> */}
    </Card>
  );
};

export default BranchList;
